module.exports = __webpack_public_path__ + "static/media/3.ae4fb565.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/shoes/3.png
// module id = 1071
// module chunks = 0